<div>
    <mat-card>
        <h2>Abmelden</h2>
    </mat-card>
</div>